import { render, staticRenderFns } from "./profile.page.vue?vue&type=template&id=5e18177d&scoped=true&"
import script from "./profile.page.vue?vue&type=script&lang=js&"
export * from "./profile.page.vue?vue&type=script&lang=js&"
import style0 from "./profile.page.vue?vue&type=style&index=0&id=5e18177d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18177d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
